import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useContext,
} from 'react';
import { To } from 'react-router-dom';

type Action = {
  onClick?: () => void;
  to?: To;
  label: ReactNode;
};

type PrimaryBuyActions = {
  primary?: Action;
  secondary?: Action;
};

export type PrimaryBuyConfirmationOptions = {
  actions?: PrimaryBuyActions;
  variant?: 'rivals' | 'pro';
};

export type BuyConfirmationProviderStateProps = {
  tokenOfferId?: string;
  onClose?: () => void;
  beforeOnClose?: () => void;
  primaryBuyId?: string;
  primaryBuyConfirmationOptions?: PrimaryBuyConfirmationOptions;
};

interface BuyConfirmationContext {
  showBuyingConfirmation: boolean;
  setBuyConfirmationProps: Dispatch<
    SetStateAction<BuyConfirmationProviderStateProps | null>
  >;
  setShowBuyingConfirmation: (bool: boolean) => void;
}

const buyConfirmationContext = createContext<BuyConfirmationContext | null>(
  null
);

export const useBuyConfirmationContext = () =>
  useContext(buyConfirmationContext)!;

export const BuyConfirmationProvider = buyConfirmationContext.Provider;
